import DeviceRowMenu from "./DeviceRowMenu";
import {Tag} from "antd";

export default function deviceColumns(t)
{
    return [
        {
            title: t('Id'),
            dataIndex: 'id',
            key: 'id',
            columnName: 'id',
            sorter: true,
            render: (text, record) => (
                <DeviceRowMenu row={record} />
            )
        },
        {
            title: t('Device Name'),
            dataIndex: 'name',
            key: 'name',
            columnName: 'name',
            sorter: true,
        },
        {
            title: t('AE Title'),
            dataIndex: 'aeTitle',
            key: 'aeTitle',
            columnName: 'aeTitle',
            sorter: true,
        },
        {
            title: t('IP Address'),
            dataIndex: 'ipAddress',
            key: 'ipAddress',
            columnName: 'ipAddress',
            sorter: true,
        },
        {
            title: t('Port'),
            dataIndex: 'port',
            key: 'port',
            columnName: 'port',
            sorter: true,
        },
        {
            title: t('Hospital'),
            dataIndex: 'hospitalName',
            key: 'hospitalName',
            columnName: 'hospital.name',
            render: (text, row) => row?.hospital?.name || '-',
            sorter: true,
        },
        {
            title: t('Modality'),
            dataIndex: 'modalityName',
            key: 'modalityName',
            columnName: 'modality.name',
            render: (text, row) => row?.modality?.name || '-',
            sorter: true,
        },
        {
            title: t('Status'),
            dataIndex: 'isActive',
            key: 'isActive',
            columnName: 'isActive',
            sorter: true,
            render: (isActive) => (
                <Tag color={isActive ? 'green' : 'red'}>
                    {isActive ? t('Active') : t('Inactive')}
                </Tag>
            )
        },
    ]
}
